import * as moment from 'moment';
import { DatepickerRange } from '../standalones/components/date-range-picker/date-range-picker.component';

export function calculatePercentage(x: number, total: number) {
  return parseFloat(((x / total) * 100).toFixed(2));
}

// Helper function to escape double quotes in CSV values and wrap the values with quotes
const escapeCSVValue = (value: any): string => {
  const strValue = String(value ?? '').replace(/"/g, '""');
  return `"${strValue}"`;
};

// Helper function to serialize a single row object to a CSV string
const serializeRowToCSV = <T>(row: T, keys: (keyof T)[]): string =>
  keys.map((key) => escapeCSVValue(row[key])).join(',');

// Main function to download data as a CSV file
export function downloadAsCSV<T>(
  filename: string,
  headers: string[],
  data: T[],
  keys: (keyof T)[],
) {
  const headerString = `${headers.map(escapeCSVValue).join(',')}\n`;
  const bodyString = data.map((row) => serializeRowToCSV(row, keys)).join('\n');
  const csvBlob = new Blob([headerString, bodyString], { type: 'text/csv' });
  const downloadLink = document.createElement('a');
  downloadLink.href = URL.createObjectURL(csvBlob);
  downloadLink.download = filename;
  downloadLink.click();
}

export enum ReportType {
  Engagement = 'Engagement',
  Attendance = 'Attendance',
  Billing = 'Billing',
  SitesAttendance = 'Site-Attendance',
  SitesCoaching = 'Site-Coaching',
}

export function generateCSVFileName(
  reportType: ReportType,
  name: string,
  datepickerRange: DatepickerRange,
) {
  return `${reportType}-${name}-${moment(datepickerRange.range.start).format('ll')}-${moment(
    datepickerRange.range.end,
  ).format('ll')}.csv`;
}
